import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui';
import { setConsent, useConsent } from '@/lib/consent';

/**
 * In normal flow at the top of the page (not fixed), so it can never cover the checkout's
 * sticky action. Accept and Refuse are the same variant and size.
 */
export function ConsentBanner() {
  const { t } = useTranslation();
  const { open } = useConsent();
  if (!open) return null;
  return (
    <section
      role="region"
      aria-labelledby="consent-title"
      className="border-b border-line bg-surface px-5 py-4"
    >
      <div className="mx-auto flex max-w-md flex-col gap-3">
        <h2 id="consent-title" className="text-sm font-bold text-ink">
          {t('consent.title')}
        </h2>
        <p className="text-sm text-ink-muted">{t('consent.body')}</p>
        <div className="grid grid-cols-2 gap-3">
          <Button variant="secondary" size="md" onClick={() => setConsent('denied')}>
            {t('consent.refuse')}
          </Button>
          <Button variant="secondary" size="md" onClick={() => setConsent('granted')}>
            {t('consent.accept')}
          </Button>
        </div>
      </div>
    </section>
  );
}
